<template>
    <footer class="footerMenu" v-if="this.$public.isCordova()">
        <div class="logo">
            <router-link :to="{ name: 'Home'}"><Logo/></router-link>
        </div>
        <router-link :to="{ name: 'Home'}" class="home" @click.native="onClickHandler('Home')"><span>首 頁</span></router-link>
        <router-link :to="{ name: 'Gift'}" class="gift" @click.native="onClickHandler('Gift')"><span>票 匣</span></router-link>
        <router-link :to="{ name: 'Scan'}" class="scanner" @click.native="onClickHandler('Scan')"><span>掃 碼</span></router-link>
        <router-link :to="{ name: 'Store'}" class="landmark" @click.native="onClickHandler('Store')"><span>附 近</span></router-link>
        <div class="notice" @click="openNotice" @click.stop><span>通知</span></div>
        <div class="notice-pop" v-if="noticePop" @click="openNotice">
            <Notification :isComponents="true"/>
        </div>

        <router-link :to="{ name: 'More'}" class="user" @click.native="onClickHandler('More')"><span>個 人</span></router-link>

        <!--購物車-->
        <AddCart v-if="this.$route.name==='MarketplaceInfo' ||
        this.$route.name==='Product' || this.$route.name==='Cart' || this.$route.name==='ProductList' ||
        this.$route.name==='MarketplaceActivityDetail'"/>
    </footer>
    <!--商圈用footer-->
    <footer class="footerMenu" v-else-if="officialName!==''">
        <div class="logo">
            <router-link :to="{ name: 'MarketplaceInfo' , params: {'officialName': officialName}}">
                <Logo/>
            </router-link>
        </div>
        <router-link :to="{ name: 'MarketplaceInfo' , params: {'officialName': officialName}}" class="home ev"><span>首 頁</span></router-link>
        <router-link :to="{ name: 'MarketplaceActivity' , params: {'officialName': officialName}}" class="activity ev"><span>活 動</span></router-link>
        <router-link :to="{ name: 'MarketplaceGift' , params: {'officialName': officialName}}"  class="gift ev"><span>票 匣</span></router-link>
        <router-link :to="{ name: 'MarketplaceArticle' , params: {'officialName': officialName}}" class="article ev"><span>貼 文</span></router-link>
        <router-link :to="{ name: 'MarketplaceMore' , params: {'officialName': officialName}}" class="user ev"><span>個 人</span></router-link>
        <!--購物車-->
        <AddCart/>
    </footer>

</template>

<script>
    import Notification from '../views/home/Notification';
    import AddCart from '../views/product/components/AddCart.vue'
    import Logo from "@/components/Logo";
    export default {
        name: "TabBar",
        components: {
            Notification,
            AddCart,
            Logo,
        },
        data() {
            return {
                //通知內容
                noticePop: false,
                officialName: this.$store.state.shopAreaInfo.officialName,
            }
        },
        mounted() {
            let self = this;
            self.removeSubscribe = self.$store.subscribe((mutation, state) => {
                if (mutation.type === "updateShopAreaInfo") {
                    let shopAreaInfo = state.shopAreaInfo;
                    self.officialName = shopAreaInfo.officialName;
                    //商圈相關頁網頁版才有底部按鈕
                    this.$emit('onChange', true);
                }
            });

            if(self.officialName === "" && !self.$public.isCordova() && sessionStorage.getItem('openShoppingAreaOfficialName') !== null) {
                self.officialName = sessionStorage.getItem('openShoppingAreaOfficialName')
                //非商圈網頁版無底部按鈕
                this.$emit('onChange', false);
            }
        },
        methods: {
            onClickHandler: function (name) {
                this.$emit('onButtonClick', name);
            },
            //電腦版開啟通知彈窗
            openNotice(){
                this.noticePop = !this.noticePop
                if(this.noticePop){
                    document.addEventListener('click', this.bodyCloseSelected)
                }else{
                    document.removeEventListener('click', this.bodyCloseSelected)
                }
            },
            //點擊空白處關閉通知彈窗
            bodyCloseSelected() {
                this.noticePop= false
            },
        },
    }
</script>

<style scoped lang="less">
    //電腦版通知彈出
    .notice-pop{
        position: absolute;
        width: 400px;
        background: #fff;
        right: 20px;
        top: calc(env( safe-area-inset-top) + 80px);
        max-height: calc(100vh - 120px);
        overflow-y: hidden;
        border: 1px solid var(--color-gray);
        border-radius: 4px;
        padding-top: 20px;
        /deep/.main{
            max-height: calc(100vh - 120px);
            overflow-y: auto;
        }
        /deep/.app-header{
            display: none;
        }
    }
</style>
